<template>
<div class="allActive">
    <el-row class="head">
        <el-col :span="12" style="padding:2px 0;background:#33CCCC;">
            <el-col :span="8" v-loading="loading" style="cursor:pointer;" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.2)" @click.native="toAllCardListPage()">
                <label style="cursor:pointer;">{{ allCardSum }}</label>
                <br>
                <span>所有卡号(张)</span>
            </el-col>
            <el-col :span="8" v-loading="loading" style="cursor:pointer;" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.2)" @click.native="toNormalCardListPage()">
                <label style="cursor:pointer;">{{ normalCardSum }}</label>
                <br>
                <span>使用中(张)</span>
            </el-col>
            <el-col :span="8" style="border:none;cursor:pointer;" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.2)" @click.native="toActiveCardListPage()">
                <label style="cursor:pointer;">{{ activeCardSum }}</label>
                <br>
                <span>待激活卡(张)</span>
            </el-col>
        </el-col>

        <el-col :span="11" :offset="1" style="padding:2px 0;background:#3091F2;">
            <el-col :span="8" v-loading="loading" style="cursor:pointer;" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.2)" @click.native="toStopCardListPage()">
                <label style="cursor:pointer;">{{ stopCardSum }}</label>
                <br>
                <span>停机卡号(张)</span>
            </el-col>
            <el-col :span="8" v-loading="loading" style="cursor:pointer;" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.2)" @click.native="toExpireCardListPage()">
                <label style="cursor:pointer;">{{ expireCardSum }}</label>
                <br>
                <span>已到期数(张)</span>
            </el-col>
            <el-col :span="8" style="border:none;cursor:pointer;" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.2)" @click.native="toWarmingCardListPage()">
                <label style="cursor:pointer;">{{ flowWarmingSum }}</label>
                <br>
                <span>流量预警(张)</span>
            </el-col>
        </el-col>
    </el-row>

	<el-row class="head">
        <el-col :span="4" style="padding:0px 0;background:#33CCCC;cursor:pointer;text-align:center;">
            <div v-if="todoOutGprsTotal>0" style="display:block;position:relative;z-index:1;" class="nav-counter nav-counter-blue">{{ todoOutGprsTotalStr }}</div>
            <el-col :span="24" v-loading="loading" element-loading-spinner="el-icon-loading" @click.native="toDataStopPage()">
                <div v-if="todoOutGprsTotal>0" style="display:block;position:relative;float:right;right:0px;top:-30px;font-size:40px;z-index:0;" class="iconfont icon-daichuli"></div>
                <label style="cursor:pointer;margin-left:30px;">{{ dataStopCardSum }}</label>
                <br>
                <span style="margin-left:30px;">数据达量停机(张)</span>
            </el-col>
        </el-col>
        <el-col :span="20">
        </el-col>
    </el-row>
    <!--列表-->
    <el-table :data="companyGprs" highlight-current-row v-loading="listLoading" style="width:100%;" v-show="gprsStatVisible">
        <el-table-column prop="apiname" label="集团客户名称" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="usernum" label="流量池用户数(个)" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="totalgprs" label="流量池总流量(MB)" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="usedgprs" label="已使用的流量(MB)" min-width="180" sortable>
        </el-table-column>
    </el-table>
</div>
</template>

<script>
import {
    getCardStat,
    getGprsStat,
    getNotice,
    getOutgprsCardsTotal
} from '../api/api';
export default {
    name: 'allActive',
    data: function () {
        return {
            allCardSum: 0,
            normalCardSum: 0,
            activeCardSum: 0,
            stopCardSum: 0,
            expireCardSum: 0,
            flowWarmingSum: 0,
            dataStopCardSum: 0,
            companyGprs: [],
            gprsStatVisible: false,
            loading: false,
            listLoading: false,
            todoOutGprsTotal: 0,
            todoOutGprsTotalStr:''
        }
    },
    methods: {
        toDataStopPage(){
            if(this.dataStopCardSum > 0){
                this.$router.replace('/datastopcard');
            }
        },
        toAllCardListPage(){
            this.$router.replace('/maincardlist/1');
        },
        toNormalCardListPage(){
            this.$router.replace('/maincardlist/2');
        },
        toActiveCardListPage(){
            this.$router.replace('/maincardlist/3');
        },
        toStopCardListPage(){
            this.$router.replace('/maincardlist/4');
        },
        toExpireCardListPage(){
            this.$router.replace('/maincardlist/5');
        },
        toWarmingCardListPage(){
            this.$router.replace('/maincardlist/6');
        }
    },
    mounted() {
        //从本地会话中获取用户
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            if (user.userlevel == 0) {
                //获取集团客户GPRS的统计信息
                // getGprsStat().then((res) => {
                //     this.companyGprs = res.data;
                //     this.gprsStatVisible = true;
                // });
                getOutgprsCardsTotal().then((res) => {
                    this.todoOutGprsTotal = res.data.todoOutGprsTotal;
                    this.todoOutGprsTotalStr=this.todoOutGprsTotal;
                    if(this.todoOutGprsTotal>99){
                        this.todoOutGprsTotalStr="99+";
                    }
                    this.loading = false;
                });
            }

            this.loading = true;
            //获取用户的卡数量统计信息
            getCardStat().then((res) => {
                this.allCardSum = res.data.allCardSum;
                this.normalCardSum = res.data.normalCardSum;
                this.activeCardSum = res.data.activeCardSum;
                this.stopCardSum = res.data.stopCardSum;
                this.expireCardSum = res.data.expireCardSum;
                this.flowWarmingSum = res.data.flowWarmingSum;
                this.dataStopCardSum = res.data.dataStopCardSum;

                this.loading = false;
            });




            getNotice().then((res) => {
                let {
                    msg,
                    code
                } = res;
                if (code !== 0) {
                    console.log("查询公告失败！");
                } else {
                    var notice = res.data;
                    if (notice.content != '' && notice.content.length > 0) {
                        this.$notify.info({
                            title: notice.title,
                            dangerouslyUseHTMLString: true,
                            message: notice.content,
                            duration: 10000,
                            position: 'bottom-right'
                        });
                    }
                }
            });

        }

    }

}
</script>

<style>
.allActive>.head>.el-col>.el-col {
    padding: 20px 0;
    border-right: solid 1px #fff;
}

.allActive .head {
    text-align: center;
    color: #fff;
    font-size: 30px;
    margin-bottom: 30px;
    margin-top: 12px;
}

.allActive .head span {
    font-size: 16px;
}


.nav-counter {
  font-size: 10px;
  position: absolute;
  float:right;
  top: 2px;
  right: -8px;
  min-width: 8px;
  height: 20px;
  line-height: 20px;
  margin-top: -11px;
  padding: 0 6px;
  font-weight: normal;
  color: white;
  text-align: center;
  text-shadow: 0 1px rgba(0, 0, 0, 0.2);
  background: #e23442;
  border: 1px solid #911f28;
  border-radius: 11px;
  background-image: -webkit-linear-gradient(top, #e8616c, #dd202f);
  background-image: -moz-linear-gradient(top, #e8616c, #dd202f);
  background-image: -o-linear-gradient(top, #e8616c, #dd202f);
  background-image: linear-gradient(to bottom, #e8616c, #dd202f);
  -webkit-box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.1), 0 1px rgba(0, 0, 0, 0.12);
  box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.1), 0 1px rgba(0, 0, 0, 0.12);
}
.nav-counter-blue {
  background: #e8616c;
  border: 1px solid #dd202f;
  background-image: -webkit-linear-gradient(top, #e8616c, #dd202f);
  background-image: -moz-linear-gradient(top, #e8616c, #dd202f);
  background-image: -o-linear-gradient(top, #e8616c, #dd202f);
  background-image: linear-gradient(to bottom, #e8616c, #dd202f);
}
</style>



// WEBPACK FOOTER //
// Main.vue?34604533